import { Box, Skeleton } from "@mantine/core";
import React from "react";

const FlagDetailsSkeleton = () => {
  return (
    <Box mt="xl" m="md">
      <Skeleton h={200} />
    </Box>
  );
};

export default FlagDetailsSkeleton;
